import { useState } from 'react';

import { Accordion, AccordionItem } from '@frontend/components/ui/accordion';
import { SearchEmpty } from '@frontend/Search/Empty/SearchEmpty';
import { SearchEmptyLoading } from '@frontend/Search/Empty/SearchEmptyLoading';
import { SearchResultLink } from '@frontend/Search/SearchResultLink';
import { Question } from '@frontend/shared/components/Question/Question';
import { useQuestionSearch } from '@frontend/shared/hooks/useQuestionSearch';

export function SearchResults({
  res,
}: {
  res: ReturnType<typeof useQuestionSearch>;
}) {
  const [selectedId, setSelectedId] = useState<string>('');
  const { loading, result } = res;

  const isEmpty = !loading && !result?.answers?.length;
  const isNotEmpty = !loading && !isEmpty;

  return (
    <>
      {loading && <SearchEmptyLoading />}
      {isEmpty && <SearchEmpty hasFilter />}
      {isNotEmpty && (
        <>
          {result?.generatedAnswer && (
            <>
              <p className="text-xl leading-6 font-bold tracking-[-0.02em] text-[rgba(3,52,38,0.9)] mt-8">
                AI Answer
              </p>
              <p className="mt-2">{result.generatedAnswer}</p>
            </>
          )}
          <p className="text-xl leading-6 font-bold tracking-[-0.02em] text-[rgba(3,52,38,0.9)] mt-8">
            {result?.generatedAnswer ? 'Sources' : 'Relevant Results'}
          </p>
          <Accordion
            type="single"
            collapsible
            className="mb-4 mt-4"
            value={selectedId}
            onValueChange={(value) => {
              setSelectedId(value || '');
            }}
          >
            {result?.answers?.map((a) => {
              const question = a.raw_answer;
              if (!question) {
                return <SearchResultLink answer={a} key={a.id} />;
              }
              return (
                <AccordionItem
                  key={question.id}
                  value={question.id}
                  className="border-none mt-1.5"
                  data-id={question.id}
                >
                  <Question
                    question={question}
                    isExpanded={selectedId === question.id}
                  />
                </AccordionItem>
              );
            })}
          </Accordion>
        </>
      )}
    </>
  );
}
